/* ==========================================================================
   Slideshow countdown timer
   Drives every [data-countdown-end] on the page (multiple slides supported).
   Reads the end time from data-countdown-end (ISO datetime); hides the timer
   once it has passed. Guarded so it initialises only once.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__countdownBannerInit) return;
  window.__countdownBannerInit = true;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function setNum(el, sel, val) {
    var x = el.querySelector(sel);
    if (x) x.textContent = pad(val);
  }

  function tick() {
    var els = document.querySelectorAll('[data-countdown-end]');
    if (!els.length) return;
    var now = new Date().getTime();

    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      var end = Date.parse(el.getAttribute('data-countdown-end') || '');
      if (isNaN(end)) { continue; }

      var diff = end - now;
      if (diff <= 0) {
        el.setAttribute('hidden', '');
        continue;
      }

      var s = Math.floor(diff / 1000);
      setNum(el, '[data-cb-days]', Math.floor(s / 86400));
      setNum(el, '[data-cb-hours]', Math.floor((s % 86400) / 3600));
      setNum(el, '[data-cb-mins]', Math.floor((s % 3600) / 60));
      setNum(el, '[data-cb-secs]', s % 60);
    }
  }

  function start() {
    tick();
    setInterval(tick, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
  // bfcache restore — recompute immediately
  window.addEventListener('pageshow', tick);
})();
